import { CountryDropdownOption } from "./CountryDropdownOption";
import { CountryDropdownSingleValue } from "./CountryDropdownSingleValue";

export const countryDropdownComponents = {
  Option: CountryDropdownOption,
  SingleValue: CountryDropdownSingleValue,
};

export const countryDropdownComponentsWithoutSingleValue = {
  Option: CountryDropdownOption,
};
